import { useMutation } from "@tanstack/react-query";
import { savePreAssessment } from "./utils.api";

export const useSavePreAssessment = () =>
    useMutation({
        mutationFn: (body) =>
            savePreAssessment(body),
    });